import fancybox from "@fancyapps/fancybox";

(function($) {
	$('[data-fancybox="gallery"]').fancybox({
		// Options will go here
	});
	$(".headerFeatured__vertical").on("click", function() {
		$(this).toggleClass("active");
	});

	$(".gallery-icon a").fancybox().attr('data-fancybox', 'gallery');
})(jQuery);
